import { RoommateData } from 'src/features/multi-occupancy/types';

export class ProcessAmendDto {
    readonly vita_ref: string;

    readonly transaction_id: string | null;

    readonly room_mates: RoommateData[];

    readonly self_serve: boolean;

    constructor(
        vitaRef: string,
        transaction_id: string | null,
        roommates: RoommateData[],
        selfServe: boolean
    ) {
        this.vita_ref = vitaRef;
        this.transaction_id = transaction_id;
        this.room_mates = roommates;
        this.self_serve = selfServe;
    }
}
